<p>subscribe-dialog works!</p>
